import { render, staticRenderFns } from "./active-filters.vue?vue&type=template&id=0589efbe&scoped=true&"
import script from "./active-filters.vue?vue&type=script&lang=js&"
export * from "./active-filters.vue?vue&type=script&lang=js&"
import style0 from "./active-filters.vue?vue&type=style&index=0&id=0589efbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0589efbe",
  null
  
)

export default component.exports